<template>
  <div>
    <DxForm
      id="cropsForm"
      caption="Crops Form"
    >
      <DxGroupItem>
        <DxSimpleItem
          :data-field="$t('DxCrops_DxSimpleItem_cropsSelector_dataField')"
          :editor-options="{
            items: cropsOptions,
            searchEnabled: true,
            searchTimeout: searchTimeoutOption,
            minSearchLength: minSearchLengthOption,
            showDataBeforeSearch: showDataBeforeSearchOption,
            onValueChanged: cropsValueChanged,
            value: initialCrops,
          }"
          editor-type="dxTagBox"
          name="cropsSelector"
        >
          <DxRequiredRule :message="$t('Required_message')" />
        </DxSimpleItem>
      </DxGroupItem>
    </DxForm>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import {
  DxForm,
  DxSimpleItem,
  DxGroupItem,
  DxRequiredRule,
} from 'devextreme-vue/form';
import 'devextreme-vue/tag-box';
import EventBus from '../../js/event-bus';

export default {
  name: 'DxCrops',
  components: {
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxRequiredRule,
  },
  props: {
    cropsOptions: {
      type: Array,
      default: () => [],
    },
    initialCrops: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      searchTimeoutOption: 200,
      minSearchLengthOption: 0,
      showDataBeforeSearchOption: false,
    };
  },
  methods: {
    cropsValueChanged(e) {
      this.setCurrentCrops(e.value);
      EventBus.$emit('cropsSelectorValueChanged', e.value);
    },
    ...mapActions('Mopeco', ['setCurrentCrops']),
  },
};
</script>

<style>
</style>
